// removed by extract-text-webpack-plugin
module.exports = {"search-product":"search-product","search-product-container":"search-product-container","product-right-list":"product-right-list","category-menu":"category-menu","title-category":"title-category","category-menu-item":"category-menu-item","item":"item","item-link":"item-link","category-sub-menu":"category-sub-menu","search-results-title":"search-results-title"};


//////////////////
// WEBPACK FOOTER
// ./components/search-product/_SearchProduct.scss
// module id = ./components/search-product/_SearchProduct.scss
// module chunks = 0